//export const host_api = 'http://172.20.10.4:5903';
//export const host_api = 'http://futmania.solutechplus.com';
export const host_api = 'https://calcio.servizieolie.com';